import { useState } from 'react'
import { useHost, useView } from '@10000/react'
import { DropDown, Form, Submit, Text } from '../../forms'
import { Body, Box, Button, Dialog, H3, H4 } from '../'
import './SupportDialog.scss'

export const SupportDialog = ({ open, onClose }) => {
  const { supportRequested } = useHost() || {}
  const { user } = useView('tenant')
  const [submitted, setSubmitted] = useState(false)

  const submit = ({ type, message }) => supportRequested(user, type, message)
    .then(() => setSubmitted(true))

  const reset = () => {
    onClose()
    setTimeout(() => setSubmitted(false), 500)
  }

  const enquiryOptions = [
    'General enquiry',
    'Becoming a partner',
    'Billing and subscriptions',
    'Running a Squiz',
    'Events and opportunities'
  ].map(x => ({
    label: x,
    value: x
  }))

  return (
    <Dialog open={open} onClose={onClose} showControls={false} mobileBackground="white">
      <Form onSubmit={submit} style={{ width: '100%' }}>
        <Box column gap={32} fullWidth>
          {submitted
            ? <H4 color="black">Your request was submitted</H4>
            : <H3 color="black">Help and support</H3>
          }
          <Box column gap={16} overflowY="auto" p={1} className="black-scroller">
            {submitted
              ? <Body color="black">A member of our support team will contact you shortly.</Body>
              : <>
                  <Body color="black">Tell us how we can help you</Body>
                  <DropDown
                    name="type"
                    title="Enquiry type"
                    options={enquiryOptions}
                    dark
                    required
                  />
                  <Text
                    name="message"
                    title="Message"
                    dark
                    required
                    multiline
                  />
                </>
            }
          </Box>
          <Box className="support-buttons" fullWidth gap={8} justifyContent="flex-end">
            {submitted
              ? <Button fullWidth onClick={reset}>Close</Button>
              : <>
                  <Submit>Send</Submit>
                  <Button light onClick={onClose}>Cancel</Button>
                </>
            }
          </Box>
        </Box>
      </Form>
    </Dialog>
  )
}